var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeSpace = function SvgHomeSpace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.8.366.8 4.41c-.5.35-.8.893-.8 1.472v8.28c0 1.012.9 1.84 2 1.84h12c1.1 0 2-.828 2-1.84v-8.28c0-.58-.3-1.122-.8-1.472L9.2.366a2.15 2.15 0 0 0-2.4 0M4.3 9.842a.75.75 0 0 0-1 1.12A7.03 7.03 0 0 0 8 12.752a7.03 7.03 0 0 0 4.7-1.792.75.75 0 1 0-1-1.12A5.53 5.53 0 0 1 8 11.254a5.54 5.54 0 0 1-3.7-1.412",
    clipRule: "evenodd"
  })));
};
export default SvgHomeSpace;